/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UIAssetFilterCreateDTO } from '../models/UIAssetFilterCreateDTO';
import type { UIAssetFilterDTO } from '../models/UIAssetFilterDTO';
import type { UIAssetFilterDTOODataListResponse } from '../models/UIAssetFilterDTOODataListResponse';
import type { UIAssetFilterGroupCreateDTO } from '../models/UIAssetFilterGroupCreateDTO';
import type { UIAssetFilterGroupDTO } from '../models/UIAssetFilterGroupDTO';
import type { UIAssetFilterGroupDTOODataListResponse } from '../models/UIAssetFilterGroupDTOODataListResponse';
import type { UIAssetFilterGroupEditDTO } from '../models/UIAssetFilterGroupEditDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UiAssetFilterService {

    /**
     * @param clientId 
     * @param query 
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns UIAssetFilterDTOODataListResponse Success
     * @throws ApiError
     */
    public static getBackendv2Uiassetfilter(
clientId?: number,
query?: string,
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<UIAssetFilterDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/uiassetfilter',
            query: {
                'clientId': clientId,
                'query': query,
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns UIAssetFilterDTO Success
     * @throws ApiError
     */
    public static postBackendv2Uiassetfilter(
requestBody?: UIAssetFilterCreateDTO,
): CancelablePromise<UIAssetFilterDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backendv2/uiassetfilter',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns UIAssetFilterDTO Success
     * @throws ApiError
     */
    public static getBackendv2Uiassetfilter1(
key: number,
): CancelablePromise<UIAssetFilterDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/uiassetfilter/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns UIAssetFilterDTO Success
     * @throws ApiError
     */
    public static putBackendv2Uiassetfilter(
key: number,
requestBody?: UIAssetFilterCreateDTO,
): CancelablePromise<UIAssetFilterDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backendv2/uiassetfilter/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendv2Uiassetfilter(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backendv2/uiassetfilter/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param clientId 
     * @param query 
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns UIAssetFilterGroupDTOODataListResponse Success
     * @throws ApiError
     */
    public static getBackendv2Uiassetfiltergroup(
clientId?: number,
query?: string,
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<UIAssetFilterGroupDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/uiassetfiltergroup',
            query: {
                'clientId': clientId,
                'query': query,
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns UIAssetFilterGroupDTO Success
     * @throws ApiError
     */
    public static postBackendv2Uiassetfiltergroup(
requestBody?: UIAssetFilterGroupCreateDTO,
): CancelablePromise<UIAssetFilterGroupDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backendv2/uiassetfiltergroup',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns UIAssetFilterGroupDTO Success
     * @throws ApiError
     */
    public static getBackendv2Uiassetfiltergroup1(
key: number,
): CancelablePromise<UIAssetFilterGroupDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/uiassetfiltergroup/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns UIAssetFilterGroupDTO Success
     * @throws ApiError
     */
    public static putBackendv2Uiassetfiltergroup(
key: number,
requestBody?: UIAssetFilterGroupEditDTO,
): CancelablePromise<UIAssetFilterGroupDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backendv2/uiassetfiltergroup/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendv2Uiassetfiltergroup(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backendv2/uiassetfiltergroup/{key}',
            path: {
                'key': key,
            },
        });
    }

}
